timeoutId = null

getIntervalSeconds = (timestamp) ->
  msFromNow = (new Date() - new Date(timestamp))

  switch
    when (msFromNow < 60000) then 5000
    when (msFromNow < 120000) then 20000
    else 60000

applyRelativeTimeAgo = (el, locale) ->
  timestamp = el.getAttribute("data-timestamp")

  # configure moment thresholds to display 'x seconds' between 5 and 55s
  m = moment
  m.relativeTimeThreshold('s', 55)
  m.relativeTimeThreshold('ss', 5)

  rel_time = m(timestamp).locale(locale).parseZone().fromNow()
  el.innerText = rel_time

  return timestamp

render = (locale) ->
  # Clear any intervals that have previously been set
  # If the locale changes or new content is added to the page
  clearInterval(timeoutId) if !!timeoutId

  lowestIntervalMs = 60000 # 60s default
  timeElements = document.querySelectorAll(
    "[data-behavior='localized-relative-time-ago']"
  )

  _.each(timeElements, (el) ->
    elTimestamp = applyRelativeTimeAgo(el, locale)

    # Update interval timer with lowest required ms
    elIntervalMs = getIntervalSeconds(elTimestamp)
    lowestIntervalMs = elIntervalMs if elIntervalMs < lowestIntervalMs
  )

  timeoutId = setTimeout(render.bind(this, locale), lowestIntervalMs)

export default render



// WEBPACK FOOTER //
// ./app/javascript/lib/toolkit/behaviors/format_relative_datetimes.js.coffee